import BreadCrumbsWrapper from "common/BreadCrumbs"
import { useIsDesktop } from "common/MediaQueries"
import Link from "next/link"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"
import {
  StyledBody,
  StyledHeaderH2,
  StyledLink,
} from "../../reusable/wrappers/BodyText"
import CenterText from "../../reusable/wrappers/CenterText"
import ImageContainer from "../../reusable/wrappers/ImageContainer"

const StyledTextWrapp = styled.div`
  margin-top: 40px;
  max-width: 1400px;
  padding-right: 150px;
  padding-left: 150px;

  ${(p) => p.theme.breakpoints.down("sm")} {
    padding-right: 20px;
    padding-left: 20px;
    h3 {
      width: 240px;
    }
    h6 {
      margin-top: 20px;
      margin-bottom: 30px;
    }
  }
`
const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  display: flex;
  align-items: center;
  background: ${(p) => p.theme.colors.lightGrey};
  padding-bottom: 80px;
`

const TermsPage = () => {
  const headerText = [
    `ריכזנו לך את כל מה שחשוב לדעת על המידע המוצג באתר, הקישורים המופיעים בו,
      אופן השמירה על הפרטים הנמסרים דרכו ועוד.`,
    `אתר מאזדה מופעל ומנוהל על ידי דלק מוטורס בע"מ ח.פ  510947153 שכתובתה ת.ד 200 ניר צבי 7290500. הביקור והשימוש באתר  מעידים על הסכמתך לתנאים אלה ולכן הנך מתבקש לקרוא אותם בעיון. באם אינך
    מסכים לתנאים, הנך מתבקש להימנע מביקור ומשימוש באתר. `,
    `המידע באתר. המידע, התיאורים, התמונות, הנתונים, ומפרטי הרכב המופיעים באתר זה הינם בעלי אופי בינלאומי, אינם תואמים לחלוטין את הרכב המיובא לישראל והם מוצגים לצורך התרשמות בלבד. מערכות, אביזרים ופרטים המופיעים בצילומים ו/או בתיאורים שבאתר, אינם נכללים בהכרח במפרט הרכב המיובא לישראל ואינם בהכרח מוצעים
    כאופציית רכישה.`,
  ]
  const isDesktop = useIsDesktop()

  return (
    <StyledPageWrapper $padding={"0"}>
      <StyledPageDiv>
        <ImageContainer
          src={
            isDesktop
              ? "/img/cover/TermsofUse.jpg"
              : "/img/cover/TermsofUsemobile.jpg"
          }
        />
        <BreadCrumbsWrapper name="TermsOfUse" />
        <StyledTextWrapp>
          <CenterText
            title="תנאי השימוש באתר מאזדה"
            headerText={headerText}
            footerText="* תנאי השימוש מנוסחים בלשון זכר מטעמי נוחות אך מתייחסת לגברים ונשים כאחד"
            margin={true}
            withBorder
          />
          <StyledHeaderH2 $margin={40}>המידע באתר</StyledHeaderH2>
          <StyledBody>
            {`החברה משקיעה מאמצים על מנת שהמידע באתר יהיה מדויק ועדכני אך אין בכך
            משום התחייבות לכך ועל כן דלק מוטורס וחברת מאזדה לא תישאנה באחריות
            כלשהי לעדכניות, לשלמות ולנכונות המידע המצוי באתר. היצרן והחברה
            שומרים לעצמם את הזכות להוסיף או לגרוע, לתקן או לשנות את מבנה האתר,
            את המידע המוצג באתר ואת תנאי הביקור והשימוש באתר, בכל עת וללא הודעה
            מוקדמת. בכל מקרה, המידע הניתן באולמות התצוגה של החברה גובר על המידע
            הכללי שבאתר זה.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {`החברה אינה מתחייבת כי כל הקישורים ("לינקים") שיימצאו באתר יהיו
            תקינים ויובילו אותך לאתר אינטרנט פעיל. החברה רשאית להסיר מהאתר
            קישורים שנכללו בו בעבר לפי שיקול דעתה הבלעדי. העובדה שתמצא באתר זה
            קישור לאתר מסוים אינה מהווה אישור לכך שהמידע באותו אתר הינו מלא,
            מהימן, עדכני או אמין.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {`  מבלי לגרוע באמור לעיל, החברה אינה אחראית לכל נזק, עקיף או ישיר
            שייגרם לך או לרכושך כתוצאה משימוש או הסתמכות על המידע והתכנים
            המופיעים באתרים אליהם תגיע באמצעות או דרך שימוש או קישור הקיימים
            באתר זה ו/או בגין שימוש או הסתמכות על מידע ותכנים המתפרסמים באתר ע"י
            צדדים שלישיים.`}
          </StyledBody>

          <StyledHeaderH2 $margin={40}>
            מדיניות השמירה על הפרטיות
          </StyledHeaderH2>
          <StyledBody>
            {` חלק מהשירותים באתר מצריכים הרשמה. במסגרת ההרשמה תידרש למסור מידע
            אישי כדוגמת שמך, כתובת מגורים, מספרי טלפון וכתובת הדואר האלקטרוני.
            החברה תשתמש במידע אישי זה רק על-פי מדיניות הפרטיות המתוארת כאן, או
            על-פי הוראות כל דין. המידע נשמר בהתאם לחוק הגנת הפרטיות, התשמ"א
            1981.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {`   החברה נוקטת בצעדים סבירים לאבטחת המידע האישי הנמסר לה והשימוש בו. עם
            זאת, החברה אינה יכולה לאבטח את מערכות המידע באופן אשר ימנע חדירות
            בלתי מורשות ושימוש אסור במידע. החברה לא תישא באחריות במקרים של גילוי
            ושימוש במידע הנמסר לה הנובע מחדירות בלתי מורשות לאתר.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {` החברה לא תמסור את המידע האישי שנמסר לה לצדדים שלישיים, אלא אם היא
            תהיה מחויבת לעשות כן על - פי דין או אם תעמוד בפני איום שינקטו כנגדה
            הליכים משפטיים בגין פעולות שבצעת באתר.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {` החברה רשאית להשתמש בפרטים שנמסרו לה באתר ובמידע שתאסוף אודות דפוסי
            השימוש באתר - לצורך שיפור השירותים שהיא מציעה, ליצירת הקשר עם מוסר
            המידע ולצרכים סטטיסטיים.כדי להשיג מטרות אלה, החברה עשויה לשתף ולמסור
            את המידע לסוכניה המורשים, למוסכי השירות המוסמכים על ידה ולמפרסמיה.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {`באתר נעשה שימוש ב"עוגיות"(cookies) כדי לאסוף נתונים סטטיסטיים אודות
            השימוש באתר וכדי להתאים את האתר להעדפותיך האישיות.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {`  "עוגיות" הן קובצי טקסט, שהדפדפן שלך יוצר לפי פקודה ממחשבי האתר ושומר
            על גבי הכונן הקשיח במחשב שלך.אם, לדוגמה, אתה משתמש במערכת ההפעלה
            "חלונות" ובדפדפן מסוג "אינטרנט אקספלורר" של חברת מיקרוסופט, תוכל
            למצוא את הקבצים בספריית C: \\Windows\\Cookies או C: \\Windows\\Temporary
            Internet Files.קבצים אלה מכילים מידע שונה כדוגמת הדפים שבהם ביקרת,
            משך הזמן בו שהית באתר, מהיכן הגעת אל האתר, מדורים ומידע שאתה מבקש
            לראות בעת הכניסה לאתר ועוד.המידע בקבצים הללו מוצפן, והחברה נוקטת
            אמצעי זהירות כדי להבטיח שרק מחשבי האתר יוכלו לקרוא ולהבין את המידע
            האגור בהם.`}
          </StyledBody>

          <StyledHeaderH2 $margin={40}>קישורים חיצוניים</StyledHeaderH2>
          <StyledBody>
            {` ייתכן שתמצא באתר קישורים (לינקים) לאתרים אחרים. קישורים אלו מוצגים
            באתר לנוחיותך בלבד. קישורים אלו אינם בשליטתה של החברה והיא אינה
            מפקחת על תוכן האתרים המקושרים. ככל שהאתר מכיל קישורים אלו, אין בכך
            כדי להעיד על הסכמה ו/או אחריות של החברה לתכנים המופיעים באתרים
            המקושרים ו/או מהווה ערובה לאמינותם, עדכניותם, תקינותם או חוקיותם
            ו/או למדיניות הפרטיות ותנאי השימוש הננקטים על ידי בעליהם. החברה אינה
            אחראית לכל תוצאה שתיגרם כתוצאה מהשימוש באתרים המקושרים ו/או מהסתמכות
            עליהם וממליצה לקרוא בעיון את תנאי השימוש ומדיניות הפרטיות של אתרים
            אלו, ככל שקיימים, ו/או לפנות לבעלי האתרים המקושרים בכל מקרה של טענה
            או בקשה בעניין.`}
          </StyledBody>

          <StyledHeaderH2 $margin={40}>קניין רוחני</StyledHeaderH2>
          <StyledBody>
            {` מלוא זכויות היוצרים והקניין הרוחני באתר, לרבות בשם וסימני המסחר,
            בעיצוב האתר, בתכנים המתפרסמים בו על ידי דלק מוטורס או מטעמה ובכל
            תוכנה, יישום, קוד מחשב, קובץ גרפי, טקסט וכל חומר אחר הכלולים בו, הנם
            של היצרן ושל דלק מוטורס בלבד. אין להעתיק, להפיץ, להציג בפומבי או
            למסור לצד שלישי כל חלק שהוא מהנ"ל בלא קבלת הסכמתה של דלק מוטורס בכתב
            ומראש. סימני המסחר ומודעות הפרסומת של מפרסמים באתר הם קניינם של
            מפרסמים אלה בלבד. גם בהם אין לעשות שימוש בלא הסכמת המפרסם בכתב
            ומראש.`}
          </StyledBody>

          <StyledHeaderH2
            $margin={40}
            style={{ fontSize: "20px", fontWeight: 300 }}
          >
            שינויים באתר והפסקת השירות
          </StyledHeaderH2>
          <StyledBody>
            {`   דלק מוטורס תשנה מעת לעת את מבנה האתר הכולל את השירותים, היקפם
            וזמינותם של השירותים הניתנים בו, את מראהו של האתר וכל היבט אחר הכרוך
            בהם - והכל, בלא צורך להודיע לך על כך מראש. שינויים אלה יבוצעו, בין
            השאר, בהתחשב באופי הדינמי של האינטרנט ובשינויים הטכנולוגיים והאחרים
            המתרחשים בתחום. מטבעם, שינויים מסוג זה עלולים להיות כרוכים בתקלות
            ו/או לגרום בתחילה אי-נוחות מסוימת. דלק מוטורס לא תישא באחריות בגין
            ביצוע שינויים כאמור ו/או תקלות שיתרחשו אגב ביצועם.`}
          </StyledBody>
          <StyledBody $margin={20}>
            {" "}
            {` דלק מוטורס איננה מתחייבת ששירותי האתר לא יופרעו, יינתנו כסדרם או ללא
            הפסקות, יתקיימו בבטחה וללא טעויות, ויהיו חסינים מפני גישה
            בלתי-מורשית למחשבי החברה או מפני נזקים, קלקולים, תקלות או כשלים -
            והכל, בחומרה, בתוכנה, בקווי ובמערכות תקשורת, אצל דלק מוטורס ו/או אצל
            מי מספקיה.`}
          </StyledBody>

          <StyledHeaderH2 $margin={40}>דין ומקום שיפוט</StyledHeaderH2>
          <StyledBody>
            {` על כל שימוש באתר ו/או על כל תביעה, דרישה או בקשה הנובעים משימוש זה
            ו/או מכל דבר ועניין אחר הקשורים באופן ישיר או עקיף לאתר זה יחולו
            דיני מדינת ישראל בלבד. מקום השיפוט יהיה בבית המשפט לו הסמכות
            בתל-אביב, והדין המהותי והפרוצדוראלי שיחול יהיה הדין הישראלי.`}
          </StyledBody>

          <StyledHeaderH2 $margin={40}>שינויים בתנאי השימוש</StyledHeaderH2>
          <StyledBody>
            דלק מוטורס שומרת לעצמה את הזכות לשנות, למחוק ו/או להוסיף על תנאי
            שימוש אלו בכל עת וללא התחייבות למתן הודעה מוקדמת ו/או בדיעבד. כל
            תוספת ו/או שינוי שנעשה באתר, בתוכן האתר ו/או בתנאים אלו יחייבו אותך
            עם המשך שימושך בו. לפיכך, אנו ממליצים לך לעיין בתנאים אלו מעת לעת.
            שימושך באתר לאחר ביצוע השינויים מעיד על הסכמתך לשינויים אלו. ככל
            שאינך מסכים לשינויים אנא הימנע מהמשך שימוש באתר או פנה אלינו לסיוע
            כדי לתת לך פתרונות חלופיים.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>שונות</StyledHeaderH2>
          <StyledBody>
            תנאי השימוש אינם יוצרים ולא יפורשו כיוצרים כל שותפות, מיזם משותף,
            יחסי עובד מעביד, סוכן או שלוח בינך לבין החברה. אם תנאי מתנאי השימוש
            ימצא בלתי חוקי, בטל או בלתי אכיף מכל סיבה, תנאי זה ימחק מתנאי השימוש
            ומחיקתו לא תשפיע על חוקיות ותקפות תנאי השימוש הנותרים. במקרה שכזה,
            יראו בקיומו של תנאי דומה אחר אכיף במקום התנאי שנמחק או הוסר.
          </StyledBody>
          <StyledBody>
            תנאי שימוש אלו מהווים את ההסכם המלא בינך לבין החברה בכל הנוגע לאופן
            השימוש באתר ומחליפים כל הבנה ו/או הסכמה אחרת, בעל-פה או בכתב, הנוגעת
            לשימוש באתר ובתוכנו.
          </StyledBody>

          <StyledHeaderH2 $margin={40}>ליצירת קשר</StyledHeaderH2>
          <StyledBody>
            ניתן לפנות אלינו לבירורים נוספים באמצעות{" "}
            <Link href="/contact-us" passHref>
              <a style={{ fontWeight: "bold", textDecoration: "underline" }}>
                טופס יצירת קשר
              </a>
            </Link>
            , או בכתובת אזור התעשייה ניר צבי, ת.ד. 200, באמצעות משלוח פקס למספר
            08-9139993, {`בדוא"ל:  `}
            <StyledLink
              href="mailto:service1@delekmotors.co.il"
              $color="#4C607E"
            >
              service1@delekmotors.co.il
            </StyledLink>{" "}
            {!isDesktop && <br></br>}
            או בטלפון מספר:{" "}
            <StyledLink
              href={"tel:*2880"}
              $color="#4C607E"
              style={{ unicodeBidi: "plaintext" }}
            >
              {" "}
              *2880
            </StyledLink>
          </StyledBody>
        </StyledTextWrapp>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default TermsPage
